import { Col, Dropdown, Grid, Image, Input, Row } from "antd";
import { CenterPopup } from "antd-mobile";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MapPin from "../../assets/images/icons/MapPin";
import { SkiResortResponse } from "../../hooks/Resorts/data";
import { useGetSkiResort } from "../../hooks/Resorts/resort.hooks";
import { P1 } from "../NormalFonts";
import { ResortDropdownProps } from "./data";
import { halfDay } from "./enumerations/halfDay";
import styles from "./styles.module.scss";

const ResortDropdown: React.FC<ResortDropdownProps> = ({
  form,
  skiResortCode,
  setShowHalfDaySelector,
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const { data: resortList } = useGetSkiResort({});
  const [showResortDropdown, setShowResortDropdown] = useState<boolean>(false);
  const [showMobilePopup, setShowMobilePopup] = useState<boolean>(false);

  const handleSelectResort = (resort: SkiResortResponse) => {
    setShowResortDropdown(false);
    setShowMobilePopup(false);
    onSelectResort(resort);
    setShowHalfDaySelector(resort.has_half_day === halfDay.YES);
  };

  const handleOpenChange = (flag: boolean) => {
    setShowResortDropdown(flag);
  };

  const renderResortDropdownContent = () => {
    return (
      <div
        className={`${styles.resortDropdownWrapper} ${
          screens.sm ? "" : styles.mobile
        }`}
      >
        <Row gutter={screens.sm ? [16, 28] : [16, 24]}>
          {resortList?.map((resort: SkiResortResponse) => {
            if (
              skiResortCode &&
              !skiResortCode.includes(resort.ski_resort_code)
            )
              return null;
            return (
              <Col key={resort.ski_resort_code} span={screens.sm ? 8 : 12}>
                <div
                  className={styles.itemWrapper}
                  onClick={() => handleSelectResort(resort)}
                >
                  <P1 color="var(--Neutral-dark-70)">
                    {t(`skiresort.${resort.ski_resort_code}`)}
                  </P1>
                  <Image
                    className={styles.resortImage}
                    src={resort.image_url}
                    preview={false}
                  />
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  };

  const togglePopup = () => {
    setShowMobilePopup(true);
  };

  const onSelectResort = (resort: SkiResortResponse) => {
    form.setFieldsValue({ locations: resort.ski_resort_code });
  };

  return (
    <>
      {screens.sm ? (
        <Dropdown
          open={showResortDropdown}
          dropdownRender={(originNode) => renderResortDropdownContent()}
          trigger={["click"]}
          onOpenChange={handleOpenChange}
        >
          <Input
            readOnly
            value={
              form.getFieldValue("locations")
                ? t(`skiresort.${form.getFieldValue("locations")}`)
                : undefined
            }
            placeholder={t("home.searchbar.resort.hint")}
            addonBefore={
              screens.lg ? null : (
                <MapPin
                  style={{
                    fontSize: 24,
                    color: "var(--Neutral-dark-80)",
                  }}
                />
              )
            }
            addonAfter={
              screens.lg ? (
                <MapPin
                  style={{
                    fontSize: 24,
                    color: "var(--Neutral-dark-80)",
                  }}
                />
              ) : null
            }
          />
        </Dropdown>
      ) : (
        <Input
          onClick={togglePopup}
          readOnly
          value={
            form.getFieldValue("locations")
              ? t(`skiresort.${form.getFieldValue("locations")}`)
              : undefined
          }
          styles={{ input: { padding: 4 } }}
          placeholder={t("home.searchbar.resort.hint")}
          addonBefore={
            screens.lg ? null : (
              <MapPin
                style={{
                  fontSize: 24,
                  color: "var(--Neutral-dark-80)",
                }}
              />
            )
          }
          addonAfter={
            screens.lg ? (
              <MapPin
                style={{
                  fontSize: 24,
                  color: "var(--Neutral-dark-80)",
                }}
              />
            ) : null
          }
        />
      )}

      <CenterPopup
        className={styles.popup}
        getContainer={() =>
          document.getElementById("containerElement") || document.body
        }
        onClose={() => setShowMobilePopup(false)}
        closeOnMaskClick={true}
        visible={showMobilePopup}
        style={{ zIndex: 10000 }}
      >
        {renderResortDropdownContent()}
      </CenterPopup>
    </>
  );
};

export default ResortDropdown;
